import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { EXTENSION_TYPE_NAME } from './constants';
import Component from './components/MuroBlock';
export const DaMuro = Node.create({
    name: EXTENSION_TYPE_NAME,
    group: 'block',
    inline: false,
    draggable: false,
    addStorage () {
        return {};
    },
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    addAttributes () {
        return {
            prompt: {
                default: null
            }
        };
    },
    parseHTML () {
        return [];
    },
    renderHTML ({ HTMLAttributes: { deviation, width, alignment, link } }) {
        return [
            'span'
        ];
    },
    addNodeView () {
        return ReactNodeViewRenderer(Component);
    },
    addCommands () {
        return {
            daMuroStartDrawing: ()=>({ editor, dispatch, tr, commands })=>{
                    if (dispatch) {
                        commands.insertContent({
                            type: this.name,
                            attrs: {}
                        });
                    }
                    return true;
                },
            daMuroUseDrawing: ()=>({ editor, chain, dispatch, tr, commands, state })=>{
                    if (dispatch) {
                        return chain().daMuroDelete().daDeviationAddDeviation({
                            deviationId: 560424901,
                            typeId: 1,
                            url: 'https://www.deviantart.com/sverkhpena/art/Kung-Fu-Fish-560424901',
                            title: 'Kung Fu Fish',
                            isJournal: false,
                            isPurchasable: false,
                            publishedTime: '2015-09-15T02:40:25-0700',
                            isTextEditable: false,
                            legacyTextEditUrl: null,
                            isShareable: true,
                            isCommentable: true,
                            isFavourited: true,
                            isDeleted: false,
                            isMature: false,
                            isDownloadable: true,
                            isAntisocial: false,
                            isBlocked: false,
                            isPublished: true,
                            blockReasons: [],
                            author: {
                                userId: 18958435,
                                useridUuid: 'f3c61edf-b5cc-4961-83b9-64b190982026',
                                username: 'sverkhpena',
                                usericon: 'https://a.deviantart.net/avatars-big/s/v/sverkhpena.jpg?8',
                                type: 'premium',
                                isNewDeviant: false
                            },
                            stats: {
                                comments: 100,
                                favourites: 598
                            },
                            media: {
                                baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f3c61edf-b5cc-4961-83b9-64b190982026/d99numd-0acb0646-e45d-46b8-bc0a-79378c4fb997.jpg',
                                prettyName: 'kung_fu_fish_by_sverkhpena_d99numd',
                                token: [
                                    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTE1OSIsInBhdGgiOiJcL2ZcL2YzYzYxZWRmLWI1Y2MtNDk2MS04M2I5LTY0YjE5MDk4MjAyNlwvZDk5bnVtZC0wYWNiMDY0Ni1lNDVkLTQ2YjgtYmMwYS03OTM3OGM0ZmI5OTcuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.VVckByeaJ4jdlBl7THOmNTx2Mvxq6fdMZIHFnjxNtbA'
                                ],
                                types: [
                                    {
                                        t: '150',
                                        r: 0,
                                        c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                        h: 109,
                                        w: 150
                                    },
                                    {
                                        t: '200H',
                                        r: 0,
                                        c: 'v1/fill/w_276,h_200,q_70,strp/<prettyName>-200h.jpg',
                                        h: 200,
                                        w: 276
                                    },
                                    {
                                        t: '300W',
                                        r: 0,
                                        c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                                        h: 217,
                                        w: 300
                                    },
                                    {
                                        t: '250T',
                                        r: 0,
                                        c: 'v1/fill/w_345,h_250,q_70,strp/<prettyName>-250t.jpg',
                                        h: 250,
                                        w: 345
                                    },
                                    {
                                        t: '350T',
                                        r: 0,
                                        c: 'v1/fill/w_483,h_350,q_70,strp/<prettyName>-350t.jpg',
                                        h: 350,
                                        w: 483
                                    },
                                    {
                                        t: '400T',
                                        r: 0,
                                        c: 'v1/fill/w_552,h_400,q_70,strp/<prettyName>-400t.jpg',
                                        h: 400,
                                        w: 552
                                    },
                                    {
                                        t: 'preview',
                                        r: 0,
                                        c: 'v1/fill/w_1050,h_761,q_70,strp/<prettyName>-pre.jpg',
                                        h: 761,
                                        w: 1050,
                                        f: 3710409
                                    },
                                    {
                                        t: 'social_preview',
                                        r: 0,
                                        c: 'v1/fill/w_1050,h_761,q_70,strp/<prettyName>-pre.jpg',
                                        h: 761,
                                        w: 1050
                                    },
                                    {
                                        t: 'fullview',
                                        r: 0,
                                        c: 'v1/fill/w_1600,h_1159,q_75,strp/<prettyName>-fullview.jpg',
                                        h: 1159,
                                        w: 1600,
                                        f: 3710409
                                    }
                                ]
                            }
                        }).run();
                    }
                    return true;
                },
            daMuroDelete: ()=>({ editor, chain, dispatch, commands, state })=>{
                    if (dispatch) {
                        const { selection } = state;
                        const node = selection.node;
                        if (node) {
                            const { tr } = state;
                            tr.deleteRange(selection.from, selection.to);
                            dispatch(tr);
                        }
                        return true;
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=muro.js.map